export default __webpack_public_path__ + "static/media/login register-06.2f84a048.png";